<template>
  <div class="pdf-preview">
    <div class="preview-toolbar">
      <span class="preview-title">{{ title }}</span>
      <div class="toolbar-actions">
        <el-button type="primary" plain size="small" @click="openNewTab">新窗口查看</el-button>
        <el-button size="small" @click="dialogVisible = true">放大预览</el-button>
      </div>
    </div>

    <el-alert v-if="loadError" :title="loadError" type="warning" show-icon :closable="false" />
    <object v-else :data="url" type="application/pdf" width="100%" :height="`${height}px`">
      <div class="fallback">
        当前浏览器不支持内嵌预览，请
        <a :href="url" target="_blank">点击打开 PDF</a>
      </div>
    </object>

    <el-dialog v-model="dialogVisible" title="PDF 预览" width="92%" top="3vh" append-to-body>
      <object :data="url" type="application/pdf" width="100%" height="760px">
        <div class="fallback">
          当前浏览器不支持内嵌预览，请
          <a :href="url" target="_blank">点击打开 PDF</a>
        </div>
      </object>
    </el-dialog>
  </div>
</template>

<script setup>
import { defineProps, onMounted, ref, watch } from 'vue'

const props = defineProps({
  url: {
    type: String,
    required: true
  },
  title: {
    type: String,
    default: 'PDF 材料预览'
  },
  height: {
    type: Number,
    default: 560
  }
})

const dialogVisible = ref(false)
const loadError = ref('')

const checkPdfUrl = async () => {
  loadError.value = ''
  if (!props.url) return
  try {
    const response = await fetch(props.url, { method: 'HEAD' })
    if (response.status === 405) {
      // 部分网关不支持 HEAD，直接放行 object 预览。
      return
    }
    if (!response.ok) {
      loadError.value = `文件访问失败（${response.status}）`
      return
    }
    const contentType = response.headers.get('content-type') || ''
    if (!contentType.includes('application/pdf')) {
      loadError.value = '该文件不是有效的 PDF 资源'
    }
  } catch (error) {
    loadError.value = '文件暂时不可访问，请稍后重试'
  }
}

const openNewTab = () => {
  window.open(props.url, '_blank', 'noopener')
}

watch(() => props.url, () => {
  checkPdfUrl()
})

onMounted(() => {
  checkPdfUrl()
})
</script>

<style scoped>
.pdf-preview {
  margin-top: 10px;
  border: 1px solid #dbeafe;
  border-radius: 14px;
  background: #ffffff;
  overflow: hidden;
  box-shadow: 0 8px 22px rgba(30, 64, 175, 0.07);
}

.preview-toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 10px 12px;
  background: linear-gradient(90deg, rgba(239, 246, 255, 0.95), rgba(240, 249, 255, 0.75));
  border-bottom: 1px solid #dbeafe;
}

:deep(.pdf-preview .el-alert) {
  margin: 10px;
}

.preview-title {
  font-weight: 600;
  color: #1e293b;
}

.toolbar-actions {
  display: flex;
  gap: 8px;
}

.fallback {
  padding: 16px;
  background: #f8fafc;
  border: 1px dashed #cbd5e1;
  margin: 10px;
  border-radius: 10px;
}

object {
  display: block;
}

@media (max-width: 768px) {
  .preview-toolbar {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }
}
</style>
